import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NbMenuService, NbIconLibraries } from '@nebular/theme';
import { AppService } from '../services/database/app/app.service';
import { EventService } from '../services/database/event/event.service';
import { SearchService } from '../services/search/search.service';

import { MENU_ITEMS } from './pages-menu';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class PagesComponent implements OnInit {
  constructor(iconsLibrary: NbIconLibraries, private appService: AppService, private searchService: SearchService, private menuService: NbMenuService, private route: ActivatedRoute, private eventService: EventService) {
    iconsLibrary.registerFontPack('fa', { packClass: 'fa', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('fas', { packClass: 'fas', iconClassPrefix: 'fa' });
  }

  public menu = [];

  ngOnInit() {
    const url = this.route['_routerState'].snapshot.url;
    this.menu = this.getDynamicMenu(this.eventService.getEventIdFromURL(url));
    this.appService.getSettings('app').subscribe((settings) => {
      this.searchService.init(settings);
    })
  }

  getDynamicMenu(eventId: string) {
    const menu = [];
    MENU_ITEMS.forEach(item => {
      let item_copy = {...item}
      item_copy.link = item_copy.link.replace(':eventId', eventId)
      menu.push(item_copy);
    });
    return menu;
  }
}
